<script>
    import Tile from "./tile.svelte";
    import { Peers_Handler } from "../../Peers.js";

    export let peer;

    $: canrender = peer.can_render_tile;

</script>

{#if $canrender}
    <Tile is_local_tile={peer.is_self}
    {peer}
    />
{/if}
